import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
  STR_CHANGE_PHONE_NUMBER,
  STR_CHANGE_THEME,
  STR_CONSULTATION_FEE_PAYMENTS,
  STR_CONTACT_US,
  STR_LOGOUT,
  STR_PAYMENT_SETTINGS,
  STR_PERSONAL_SETTINGS,
  STR_SUBSCRIPTION_FEE_PAYMENTS,
  STR_UPDATE_PERSONAL_INFO,
  STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdColorize, MdInfoOutline, MdLogout, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { IoColorPaletteOutline } from "react-icons/io5";
import LoginView from '../views/LoginView';

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    await appContext.getCurrentUserData();
    setReady(true);
  }

  function logOut() {
    appContext.setShowOverlayLoader(true);
    setCookie('userId', "", -10000000);
    setCookie('userToken', "", -10000000);
    appContext.navTo({
      item: '',
    })
    appContext.refresh();
    appContext.setShowOverlayLoader(false);
  }

  useEffect(() => {
    init();
  }, [])



  if(appContext.auth && appContext.currentUserData) {
    if (ready) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            overflow: "scroll",
            paddingTop: "20px"
          }}
          className="mNoScrollBar"
        >
          <div className="container">
  
            <div className="row">
  
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4">
                        <AiOutlineUser size={60} />
                      </div>
  
                      <div className="col-8">
                        <span
                          style={{
                            display: "block",
                            fontSize: "18px"
                          }}
                          className="font-semi-bold"
                        >
                          <span
                            style={{
                              display: "block",
                              fontSize: "20px"
                            }}
                            className="font-bold text-secondary"
                          >
                            +{appContext.currentUserData.phone}
                          </span>
  
                          <span
                            style={{
                              display: "block",
                              fontSize: "18px",
                              textTransform: "capitalize",
                            }}
                            className="font-semi-bold"
                          >
                            {appContext.currentUserData.username} 
                          </span>
                          
                        </span>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>
  
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body">
                    <h6
                      className="card-title"
                    >
                      {STR_PERSONAL_SETTINGS[appContext.language]}
                    </h6>
  
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",
  
                      }}
                      onClick={() => {
                        appContext.navTo({
                          item: 'view',
                          subItem: 'my-subscription',
                        })
                      }}
                    >
                      <MdOutlinePayment className="align-self-center mNoMargin" size={24} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {STR_SUBSCRIPTION_FEE_PAYMENTS[appContext.language]}
                      </h6>
                    </div>
  
                    {/*
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",
                      }}
  
                      onClick={() => {
                        appContext.navTo({
                          item: 'view',
                          subItem: 'change-phone',
                        })
                      }}
                    >
                      <MdOutlinePhonelinkSetup className="align-self-center mNoMargin" size={24} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {STR_CHANGE_PHONE_NUMBER[appContext.language]}
                      </h6>
                    </div>
                    */}
  
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",
  
                      }}
                      onClick={() => {
                        appContext.navTo({
                          item: 'view',
                          subItem: 'update-personal-info',
                        })
                      }}
                    >
                      <MdInfoOutline className="align-self-center mNoMargin" size={24} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {STR_UPDATE_PERSONAL_INFO[appContext.language]}
                      </h6>
                    </div>
  
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (appContext.language === 'en') {
                          appContext.setLanguage("sw");
                        } else {
                          appContext.setLanguage("en");
                        }
                      }}
                    >
                      <MdTranslate className="align-self-center mNoMargin" size={24} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {(appContext.language === 'en') ? "Tumia Kiswahili" : "Use English"}
                      </h6>
                    </div>
  
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        appContext.changeTheme();
                      }}
                    >
                      <IoColorPaletteOutline className="align-self-center mNoMargin" size={24} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {STR_CHANGE_THEME[appContext.language]}
                      </h6>
                    </div>
  
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        appContext.activateDialog({
                          message: STR_LOGOUT[appContext.language] + "?",
                          onConfirm: logOut,
                        })
                      }}
                    >
                      <MdLogout className="align-self-center mNoMargin" size={24} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {STR_LOGOUT[appContext.language]}
                      </h6>
                    </div>
  
                    <div
                      className="d-flex mb-4 mt-4"
                      style={{
                        padding: "0",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        appContext.navTo({
                          item: 'view',
                          subItem: 'contact-us',
                        })
                      }}
                    >
                      <MdSupportAgent className="align-self-center mNoMargin" size={24} />
                      <h6
                        className="mNoMargin align-self-center font-semi-bold"
                        style={{
                          fontSize: "14px",
                          paddingLeft: "20px",
                        }}
                      >
                        {STR_CONTACT_US[appContext.language]}
                      </h6>
                    </div>
  
                  </div>
                </div>
              </div>
  
              
  
            </div>
  
          </div>
  
  
        </div>
      )
    } else {
      return (
        <div
          className="mSupportLoading"
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          {getInlineLoader()}
        </div>
      );
    }
  
  } else {
    return (
      <LoginView/>
    )
  }

}